/**
 * Thin reusable horizontal progress bar with a gold-gradient fill.
 *
 * Props:
 *   - pct   number   0–100  (clamped automatically)
 *   - width string?  CSS width (default: auto)
 */
export default function ProgressBar({ pct, width }) {
  return (
    <div className="progress-bar-wrap" style={width ? { width } : undefined}>
      <div className="progress-bar-fill" style={{ width: `${Math.max(0, Math.min(100, pct))}%` }} />
    </div>
  );
}
